/// <reference lib="dom" />
import type { ChartLayer } from "../core/chart.ts";

export interface BandDatum {
  id: string;
  x0: number;
  x1: number;
  color?: string;
  opacity?: number;
}

export interface BandLayerOpts {
  id?: string;
}

export interface BandLayer extends ChartLayer {
  set(bands: BandDatum[]): void;
}

export function BandLayer(opts: BandLayerOpts = {}): BandLayer {
  let bands: BandDatum[] = [];
  return {
    id: opts.id ?? "bands",
    clip: true,
    set(next) {
      bands = next;
    },
    render(root, ctx) {
      const { x, theme } = ctx;
      const { inner } = ctx.frame;
      root.selectAll<SVGRectElement, BandDatum>("rect")
        .data(bands, (b) => b.id)
        .join("rect")
        .attr("x", (b) => Math.min(x(b.x0), x(b.x1)))
        .attr("width", (b) => Math.abs(x(b.x1) - x(b.x0)))
        .attr("y", inner.top)
        .attr("height", inner.height)
        .attr("fill", (b) => b.color ?? theme.series)
        .attr("fill-opacity", (b) => b.opacity ?? theme.bandOpacity)
        .style("pointer-events", "none");
    },
  };
}
